import { useGenericApi } from "./useGenericApi";
import { fetchFreightDocument } from "../helpers/apis/freightDocumentHelper";

export const useFreightDocument = (culture: string): string | null => {
    const { data } = useGenericApi<string | null>(
        ["freightDocument", culture],
        () => fetchFreightDocument(culture),
        { enabled: !!culture }
    );

    return data ?? null;
};
